import { Localidade } from './localidade.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class LocalidadeService {

    constructor(private http: Http){
    }

    getLocalidades(): Observable<Localidade[]> {
        return this.http.get(`${NTECH_API}/localidade`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/localidade/localidade.service.ts